import { PropsWithChildren } from "react";
import { useUserContext } from "../../../context/user.context";
import { Permission } from "../../../models/group.model";
import PageLoader from "../../components/PageLoader/PageLoader";
import Forbidden from "../pages/Forbidden/Forbidden";

// Gates a screen behind a specific permission, independent of org/super admin status - the
// route-level backstop so navigating directly to a URL (bypassing the sidebar's own permission
// check) still can't reach the page. Mirrors RequireOrgAdmin/RequireSuperAdmin's loading pattern.
//
// Checks "anywhere in the org" (hasPermissionAnywhereInOrg), not hasPermission(permission) with
// no facilityId -- most of these permissions (e.g. adminManageUploads) are facility-scoped, so a
// user with the permission at some but not all facilities has no org-wide role and would be
// wrongly blocked here before the page (which does its own, properly facility-scoped checks) even
// gets to mount.
function RequirePermission({ permission, children }: PropsWithChildren<{ permission: Permission }>) {
  const { loading, hasPermissionAnywhereInOrg } = useUserContext();

  if (loading) {
    return <PageLoader />;
  }

  if (!hasPermissionAnywhereInOrg(permission)) {
    return <Forbidden />;
  }

  return <>{children}</>;
}

export default RequirePermission;
